import React from 'react';
import { useNavigate } from 'react-router-dom';

function RestaurantDashboardScreen() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('restaurantId');
    navigate('/restaurant/login');
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Painel do Restaurante</h2>
      <div style={styles.grid}>
        <button style={styles.button} onClick={() => navigate('/restaurant/manage-users')}>
          Gerenciar Garçons
        </button>
        <button style={styles.button} onClick={() => navigate('/restaurant/manage-menu')}>
          Gerenciar Cardápio
        </button>
        <button style={styles.button} onClick={() => navigate('/restaurant/manage-devices')}>
          Gerenciar Dispositivos
        </button>
        <button style={styles.button} onClick={() => navigate('/restaurant/profile')}>
          Editar Perfil do Restaurante
        </button>
        <button style={styles.button} onClick={() => navigate('/restaurant/manage-restaurant-users')}>
          Gerenciar Usuários Admin/Gerente
        </button>
      </div>
      <button style={styles.logoutButton} onClick={handleLogout}>
        Sair
      </button>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f0f2f5',
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
  },
  title: {
    color: '#333',
    marginBottom: '40px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    width: '100%',
    maxWidth: '800px',
    marginBottom: '40px',
  },
  button: {
    padding: '20px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer',
    transition: 'background-color 0.2s, transform 0.2s',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  buttonHover: {
    backgroundColor: '#0056b3',
    transform: 'translateY(-2px)',
  },
  logoutButton: {
    padding: '10px 20px',
    backgroundColor: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  logoutButtonHover: {
    backgroundColor: '#c82333',
  },
};

export default RestaurantDashboardScreen;
